module.exports = __webpack_public_path__ + "static/media/int_3.4b611500.jpg";